import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getTitleFromPath(path: string): string {
  const titleMap: Record<string, string> = {
    "/": "Home",
    "/pdf-compressor": "PDF Compressor",
    "/rsa-tools": "RSA Tools",
    "/web-chat": "Web Chat",
    "/date-converter": "Date Converter",
    "/pdf-encrypter-decrypter": "PDF Encrypter Decrypter",
    "/privacy": "Privacy",
    "/notifications": "Notifications",
  };
  return titleMap[path] || "Home";
}


export function parseMessage(rawData:any) {
  try {
    const data = JSON.parse(rawData);

    if (typeof data.message === 'object' && data.message.type === 'Buffer' && Array.isArray(data.message.data)) {
      // Convert Buffer to string
      const messageText = Buffer.from(data.message.data).toString();
      return `${data.from}: ${messageText}`;
    } else if (typeof data.message === 'string') {
      // If message is already a string
      return `${data.from}: ${data.message}`;
    } else {
      console.warn('Unexpected message format:', data);
      return null;
    }
  } catch (error) {
    console.error('Error parsing JSON:', error);
    return null;
  }
}

